import { CurrentBidsDTO, MappedCurrentBid } from "./currentBids.type";

export const mapCurrentBids = (result: CurrentBidsDTO): MappedCurrentBid[] => {
  const currentBids = result.currentBids.map(bid => {
    return {
      vrm: bid.vrm,
      currentBid: bid.currentBid
    };
  });

  return currentBids;
}